import useReports from "./hook/useReports";
import TableHeadings from '../../components/Common-components/table-headings'
import { imageBaseUrl } from "../../components/Constant";
import { Spinner } from '../../components/Common-components/spinner';
import TableContainer from "./component/tableContainer";
import { Avatar } from "@mui/material";
import moment from "moment-timezone";
import ReadMoreButton from "../../components/Common-components/ReadMoreLess";
import { useTranslation } from "react-i18next";
const Cancelled = () => {
    const { t } = useTranslation();
    const {
        handlePagination,
        cancelledTableHead,
        details,
        loader,
        totalCount,
        controller,
    } = useReports();

    return (
        <>
            {loader && <Spinner />}
            <TableContainer handlePagination={handlePagination} data={details} totalCount={totalCount} title={`${t("boxTitle.Cancelled")}`} controller={controller}>
                <table className="table ">
                    <TableHeadings removeTr={true} TableHeadData={cancelledTableHead} />
                    <tbody>
                        {details?.map((cur, index) => (
                            <>
                                <tr className='fw-4 font-12' key={cur?._id} >
                                    <td>{cur?.bookingReferenceNumber}</td>
                                    <td>{cur?.clientName ?? "-"}</td>
                                    <td >{moment(cur?.cancelDate).format("ll")}</td>
                                    <td> <ReadMoreButton text={cur?.cancelReason} maxLength={100} /></td>
                                    <td>{cur?.name ?? "-"}</td>
                                    <td>{cur?.finalPrice ?? "-"}</td>
                                </tr>
                                <tr className='default_tr_gap'> </tr>

                            </>
                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </>

    )
}

export default Cancelled
